import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppDownloadIcon } from "../../Icon/AppDownloadIcon";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IDownloadToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const DownloadToolButton = (props: IDownloadToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Download}
        icon={<AppDownloadIcon />}
    />
);
